import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVertically24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFlipVertically24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m18.481 16.764-1.563-10a1.5 1.5 0 0 0-1.482-1.268h-.935v-1.5h.935A3 3 0 0 1 18.4 6.533l1.563 10A3 3 0 0 1 17 19.996h-2.498v-1.5H17a1.5 1.5 0 0 0 1.482-1.732M9.5 3.996v1.5h-.935a1.5 1.5 0 0 0-1.482 1.268l-1.563 10A1.5 1.5 0 0 0 7 18.496h2.498v1.5H7a3 3 0 0 1-2.964-3.463l1.563-10a3 3 0 0 1 2.964-2.537zm3.25-1.246a.75.75 0 0 0-1.5 0v18.496a.75.75 0 0 0 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipVertically24);
